import { render } from "./SearchViews.vue?vue&type=template&id=4f2b5ef1"
import script from "./SearchViews.vue?vue&type=script&lang=js"
export * from "./SearchViews.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/staging.hikeseo.co/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__